import React from 'react';

export const PageNull = () => {
  return <div />;
};
